import React from 'react';
import classNames from 'classnames';
import { FloatingArrow } from '@floating-ui/react';
import { useToggletipContext } from '../../Toggletip';
import * as styles from './ToggletipArrow.module.scss';

export const ToggletipArrow = () => {
  const { arrowRef, context, variant } = useToggletipContext();
  const isDark = variant === 'dark';

  return (
    <FloatingArrow
      data-testid="toggletipArrow"
      className={classNames(styles.arrow, { [styles.dark]: isDark })}
      ref={arrowRef}
      context={context}
      // Dark has no border, so skip the stroke (it would draw a white line along the base)
      fill={isDark ? 'currentColor' : 'white'}
      stroke="currentColor"
      strokeWidth={isDark ? 0 : 1}
    />
  );
};
